import { type RootState } from "~/app/store";

export const selectIsAuthOverlayOpen = (state: RootState) => state.authOverlay.isOpen;
export const selectAuthView = (state: RootState) => state.authOverlay.view;
export const selectAuthOverlayOptions = (state: RootState) => state.authOverlay;
